import _ from 'lodash';
import {
  Service,
  StaffMember,
  ReservedLocationIds,
} from '@wix/bookings-uou-types';
import { CalendarState } from '../../components/BookingCalendar/controller';
import { BottomSectionStatus } from '../../components/BookingCalendar/ViewModel/widgetViewModel/widgetViewModel';
import { FilterTypes } from '../../components/BookingCalendar/ViewModel/filterViewModel/filterViewModel';
import {
  BookingsQueryParams,
  WixOOISDKAdapter,
} from '@wix/bookings-adapter-ooi-wix-sdk';
import { Booking } from '@wix/ambassador-bookings-server/types';
import { EmptyStateType } from '../../components/BookingCalendar/ViewModel/emptyStateViewModel/emptyStateViewModel';
import { SlotsStatus } from '../../types/types';

export function createInitialState({
  service,
  wixSdkAdapter,
  staffMembers,
  rescheduleBookingDetails,
  initialErrors,
}: {
  service?: Service;
  wixSdkAdapter: WixOOISDKAdapter;
  staffMembers?: StaffMember[];
  rescheduleBookingDetails?: Booking;
  initialErrors: EmptyStateType[];
}): CalendarState {
  let locationFilterOptions: string[] = [];
  const locationQueryParam = wixSdkAdapter.getUrlQueryParamValue(
    BookingsQueryParams.LOCATION,
  );
  if (locationQueryParam) {
    if (Array.isArray(locationQueryParam)) {
      locationFilterOptions = locationQueryParam;
    } else {
      locationFilterOptions.push(locationQueryParam);
    }

    locationFilterOptions = locationFilterOptions.filter(
      (location) => location !== ReservedLocationIds.OTHER_LOCATIONS,
    );
  }

  const staffFilterOptions: string[] = [];
  if (staffMembers) {
    const staffMemberId = staffMembers?.[0]?.id;
    if (
      staffMemberId &&
      _.find(service?.staffMembers, ({ id }) => id === staffMemberId)
    ) {
      staffFilterOptions.push(staffMemberId);
    }
  }

  return {
    bottomSectionStatus: BottomSectionStatus.LOADING,
    slotsStatus: SlotsStatus.LOADING,
    selectedService: service,
    selectedDate: undefined,
    selectedTimezone: undefined,
    selectedTime: undefined,
    availableSlots: undefined,
    selectableSlotsAtSelectedTime: undefined,
    selectedRange: undefined,
    availableSlotsPerDay: undefined,
    selectedBookingPreferences: [],
    calendarErrors: [],
    rescheduleBookingDetails,
    dialog: undefined,
    filterOptions: {
      [FilterTypes.LOCATION]: locationFilterOptions,
      [FilterTypes.STAFF_MEMBER]: staffFilterOptions,
    },
    initialErrors,
  };
}
